import React, {useEffect, useState} from 'react';
import {Button, Checkbox, Form, Input, Modal, Popconfirm, Select} from 'antd';
import {useDispatch} from 'react-redux';
import {IoMdAdd} from 'react-icons/io';
import IconBtn from '../../microComponents/elements/IconBtn';
import {getFilterProductLine} from "../../microComponents/tablePages/getFilterProductLine";
import GetProductList from "../Products/GetProductList";
import ProductSeries from "../../http_request/Model/ProductSeries/ProductSeries";
import {getAgainHandler} from "../../store/TableRedux/TableRedux";
import Batch from "../../http_request/Model/batch/Batch";
import {toast} from "react-toastify";


const AddBatch = () => {
    const [form] = Form.useForm();

    const [loading, setLoading] = useState(false);
    const [productList, setProductList] = useState([]);
    const [productListLoading, setProductListLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();
    const [productLineLoading, setProductLineLoading] = useState(false);
    const [filterProductLine, setFilterProductLine] = useState([]);
    const [productLineItem, setProductLineItem] = useState();
    const [selectedProduct, setSelectedProduct] = useState();
    const handleShow = () => {

        setOpen(true);

    };


    const onFinishFailed = () => {
    };

    const onFinish = (values) => {
        ProductSeries.request({
            beforeSend: () => {
                setLoading(true)
            }, success: (result) => {
                toast.success('درخواست شما با موفقیت انجام شد.');

                dispatch(getAgainHandler());
                form.resetFields()
                handleCancel()


            }, error: (error) => {
                toast.error(error.data.message)
                // toast.error('درخواست شما با موفقیت انجام شد.');

                setLoading(false)
            }, final: () => {
                setLoading(false)
            }


        }).createBatch(values)
    };
    const handleCancel = () => {
        setOpen(false);
    };

    useEffect(() => {
        getFilterProductLine(setFilterProductLine, setProductLineLoading)


        GetProductList(setProductList, setProductListLoading)

    }, []);

    const GetProductLineProduct = (e) => {

        Batch.request({
            beforeSend: () => {
                setProductListLoading(true)
            }, success: (result) => {
                setProductLineItem(result.value)
            }, final: () => {
                setProductListLoading(false)
            }

        }).ProductSeriesLine(e)


    }
    return (
        <>
            <IconBtn onClick={handleShow} color='greenIconBtn' TooltipText='اضافه کردن بچ جدید'>
                <IoMdAdd/>
            </IconBtn>

            <Modal
                open={open}
                title='اضافه کردن بچ جدید'
                onCancel={handleCancel}
                footer={[
                    <Button className='defBtn redBtn' key='back' onClick={handleCancel}>
                        انصراف
                    </Button>,
                    productLineItem !== selectedProduct ?
                        <Popconfirm title="محصول انتخابی با سری تولید متفاوت است."
                                    onConfirm={() => form.submit()}>
                            <Button className='defBtn blueBtn' key='submit' type='primary' loading={loading}>
                                ثبت
                            </Button></Popconfirm> : <Button onClick={() => {
                            form.submit()
                        }} className='defBtn blueBtn' key='submit' type='primary' loading={loading}>
                            ثبت
                        </Button>,

                ]}
            >
                <Form
                    form={form} initialValues={{ forExport: false }}
                    name="basic"
                    layout='vertical'
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >


                    <Form.Item
                        name="productLine"
                        label="خط تولید"
                        rules={[{
                            required: true, message: 'لطفا خط تولید را وارد کنید!',
                        },]}

                    >
                        <Select showSearch
                                loading={productLineLoading}
                                filterOption={(input, option) => {
                                    return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                                }}
                                onChange={(e) => {
                                    GetProductLineProduct(e)
                                    // setProductLine(e)
                                }}
                                optionFilterProp='label'
                                options={filterProductLine}/>
                    </Form.Item>
                    <Form.Item
                        name="product"
                        label="محصول"
                        rules={[{
                            required: true, message: 'لطفا محصول را وارد کنید!',
                        },]}

                    >


                        <Select showSearch
                                filterOption={(input, option) => {
                                    return (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())
                                }}
                                onChange={(e) => {
                                    setSelectedProduct(e)
                                }}

                                loading={productListLoading}
                                options={productList}/>
                    </Form.Item>


                    <Form.Item
                        label="شماره بچ"
                        name="batchNumber"
                        rules={[
                            {
                                required: true,
                                message: 'لطفا شماره بچ را وارد کنید!',
                            },
                        ]}
                    >
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label=" صادراتی"
                        name="forExport"
                        valuePropName="checked"
                    >
                        <Checkbox />
                    </Form.Item>
                </Form> </Modal>
        </>

    );
};
export default AddBatch;